/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * WorshipInitiative.Devo.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiAuthRedirectCookieParams,
  GetApiDevosProgressParams,
  GetApiDevosSeriesProgressParams,
  GetApiReferralMetricsParams,
  GetApiStripeCheckoutSessionParams,
  GetApiStripePromotionCodeParams,
  GetContentProgress,
  GetCreatePromotionCodeCheckoutSessionResponse,
  GetCreateSubscriptionWithCouponResponse,
  GetDevotionalSeriesProgress,
  GetListenHistoryResponse,
  GetMyPromotionCodeListResponse,
  GetPortalUrlResponse,
  GetPrice,
  GetPromotionCodeInfo,
  GetReferralMetrics,
  GetShareCountResponse,
  GetSharerDisplayNameResponse,
  GetStreakInfo,
  GetSubscriptionStatus,
  GetUser,
  GetUserShareStatsResponse,
  ModelsSmsMarketingConsentResponse,
  ModelsUpdateNotificationSettingsRequest,
  ModelsUpdateSmsMarketingConsentRequest,
  MvcProblemDetails,
  PostApiOptInBody,
  PostCreatePromotionCodeCheckoutSessionRequest,
  PostCreateSubscriptionWithCouponRequest,
  PostFavorite,
  PostFollowSeries,
  PostListenProgress,
  PostPBTMessage,
  PostPBTStatusMessage,
  PostReferral,
  PostSendLoginCodeV2,
  PostShareEventRequest,
  PostUserProfile,
  PostVerifyLoginCode
} from './model';

import { apiMutator } from '../http/mutator';
type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




/**
 * This will send a text using Twilio's Verify service to send a text to the user with a code. Requires a valid Turnstile token.
 * @summary Send login code from Twilio (Turnstile protected)
 */
export const postApiAuthV2Login = (
    postSendLoginCodeV2: PostSendLoginCodeV2,
 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/auth/v2/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSendLoginCodeV2, signal
    },
      );
    }



export const getPostApiAuthV2LoginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthV2Login>>, TError,{data: PostSendLoginCodeV2}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAuthV2Login>>, TError,{data: PostSendLoginCodeV2}, TContext> => {

const mutationKey = ['postApiAuthV2Login'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuthV2Login>>, {data: PostSendLoginCodeV2}> = (props) => {
          const {data} = props ?? {};

          return  postApiAuthV2Login(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiAuthV2LoginMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuthV2Login>>>
    export type PostApiAuthV2LoginMutationBody = PostSendLoginCodeV2
    export type PostApiAuthV2LoginMutationError = unknown

    /**
 * @summary Send login code from Twilio (Turnstile protected)
 */
export const usePostApiAuthV2Login = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthV2Login>>, TError,{data: PostSendLoginCodeV2}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAuthV2Login>>,
        TError,
        {data: PostSendLoginCodeV2},
        TContext
      > => {

      const mutationOptions = getPostApiAuthV2LoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * This will verify the code sent via PBT/Twilio's Verify service.  If successful, a secure
            HTTP-only cookie will be issued
 * @summary Verifies the user's code from PBT for US/CA and Twilio for Int'l
 */
export const postApiAuthVerify = (
    postVerifyLoginCode: PostVerifyLoginCode,
 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/auth/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postVerifyLoginCode, signal
    },
      );
    }



export const getPostApiAuthVerifyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthVerify>>, TError,{data: PostVerifyLoginCode}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAuthVerify>>, TError,{data: PostVerifyLoginCode}, TContext> => {

const mutationKey = ['postApiAuthVerify'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuthVerify>>, {data: PostVerifyLoginCode}> = (props) => {
          const {data} = props ?? {};

          return  postApiAuthVerify(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiAuthVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuthVerify>>>
    export type PostApiAuthVerifyMutationBody = PostVerifyLoginCode
    export type PostApiAuthVerifyMutationError = unknown

    /**
 * @summary Verifies the user's code from PBT for US/CA and Twilio for Int'l
 */
export const usePostApiAuthVerify = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthVerify>>, TError,{data: PostVerifyLoginCode}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAuthVerify>>,
        TError,
        {data: PostVerifyLoginCode},
        TContext
      > => {

      const mutationOptions = getPostApiAuthVerifyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Removes the user's cookie
 * @summary Logs the user out
 */
export const getApiAuthLogout = (

 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/auth/logout`, method: 'GET', signal
    },
      );
    }




export const getGetApiAuthLogoutQueryKey = () => {
    return [
    `/api/auth/logout`
    ] as const;
    }


export const getGetApiAuthLogoutQueryOptions = <TData = Awaited<ReturnType<typeof getApiAuthLogout>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthLogout>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAuthLogoutQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthLogout>>> = ({ signal }) => getApiAuthLogout(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAuthLogout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiAuthLogoutQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAuthLogout>>>
export type GetApiAuthLogoutQueryError = unknown


export function useGetApiAuthLogout<TData = Awaited<ReturnType<typeof getApiAuthLogout>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthLogout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthLogout>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthLogout>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiAuthLogout<TData = Awaited<ReturnType<typeof getApiAuthLogout>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthLogout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthLogout>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthLogout>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiAuthLogout<TData = Awaited<ReturnType<typeof getApiAuthLogout>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthLogout>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Logs the user out
 */

export function useGetApiAuthLogout<TData = Awaited<ReturnType<typeof getApiAuthLogout>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthLogout>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiAuthLogoutQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Only works on *.theworshipinitiative.com
 * @summary Get temp token for sing.[env.]theworshipinitiative.com redirect
 */
export const getApiAuthGetRedirectToken = (

 signal?: AbortSignal
) => {


      return apiMutator<string>(
      {url: `/api/auth/get-redirect-token`, method: 'GET', signal
    },
      );
    }




export const getGetApiAuthGetRedirectTokenQueryKey = () => {
    return [
    `/api/auth/get-redirect-token`
    ] as const;
    }


export const getGetApiAuthGetRedirectTokenQueryOptions = <TData = Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAuthGetRedirectTokenQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>> = ({ signal }) => getApiAuthGetRedirectToken(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiAuthGetRedirectTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>>
export type GetApiAuthGetRedirectTokenQueryError = void


export function useGetApiAuthGetRedirectToken<TData = Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiAuthGetRedirectToken<TData = Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiAuthGetRedirectToken<TData = Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get temp token for sing.[env.]theworshipinitiative.com redirect
 */

export function useGetApiAuthGetRedirectToken<TData = Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetRedirectToken>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiAuthGetRedirectTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Authenticates temp token from devo.[env.]theworshipinitiative.com and writes cookie for [env.]theworshipinitiative.com
 * @summary Cookie update for sing.[env.]theworshipinitiative.com redirect
 */
export const getApiAuthRedirectCookie = (
    params?: GetApiAuthRedirectCookieParams,
 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/auth/redirect-cookie`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAuthRedirectCookieQueryKey = (params?: GetApiAuthRedirectCookieParams,) => {
    return [
    `/api/auth/redirect-cookie`, ...(params ? [params]: [])
    ] as const;
    }


export const getGetApiAuthRedirectCookieQueryOptions = <TData = Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError = unknown>(params?: GetApiAuthRedirectCookieParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAuthRedirectCookieQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthRedirectCookie>>> = ({ signal }) => getApiAuthRedirectCookie(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiAuthRedirectCookieQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAuthRedirectCookie>>>
export type GetApiAuthRedirectCookieQueryError = unknown


export function useGetApiAuthRedirectCookie<TData = Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError = unknown>(
 params: undefined |  GetApiAuthRedirectCookieParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthRedirectCookie>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthRedirectCookie>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiAuthRedirectCookie<TData = Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError = unknown>(
 params?: GetApiAuthRedirectCookieParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthRedirectCookie>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthRedirectCookie>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiAuthRedirectCookie<TData = Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError = unknown>(
 params?: GetApiAuthRedirectCookieParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Cookie update for sing.[env.]theworshipinitiative.com redirect
 */

export function useGetApiAuthRedirectCookie<TData = Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError = unknown>(
 params?: GetApiAuthRedirectCookieParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthRedirectCookie>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiAuthRedirectCookieQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const postApiWebhooksCustomerioSmsMarketingOptOut = (

 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/webhooks/customerio/sms/marketing-opt-out`, method: 'POST', signal
    },
      );
    }



export const getPostApiWebhooksCustomerioSmsMarketingOptOutMutationOptions = <TError = MvcProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsMarketingOptOut>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsMarketingOptOut>>, TError,void, TContext> => {

const mutationKey = ['postApiWebhooksCustomerioSmsMarketingOptOut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsMarketingOptOut>>, void> = () => {


          return  postApiWebhooksCustomerioSmsMarketingOptOut()
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiWebhooksCustomerioSmsMarketingOptOutMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsMarketingOptOut>>>

    export type PostApiWebhooksCustomerioSmsMarketingOptOutMutationError = MvcProblemDetails

    export const usePostApiWebhooksCustomerioSmsMarketingOptOut = <TError = MvcProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsMarketingOptOut>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsMarketingOptOut>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiWebhooksCustomerioSmsMarketingOptOutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

export const postApiWebhooksCustomerioSmsTransactionalOptOut = (

 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/webhooks/customerio/sms/transactional-opt-out`, method: 'POST', signal
    },
      );
    }



export const getPostApiWebhooksCustomerioSmsTransactionalOptOutMutationOptions = <TError = MvcProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsTransactionalOptOut>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsTransactionalOptOut>>, TError,void, TContext> => {

const mutationKey = ['postApiWebhooksCustomerioSmsTransactionalOptOut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsTransactionalOptOut>>, void> = () => {


          return  postApiWebhooksCustomerioSmsTransactionalOptOut()
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiWebhooksCustomerioSmsTransactionalOptOutMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsTransactionalOptOut>>>

    export type PostApiWebhooksCustomerioSmsTransactionalOptOutMutationError = MvcProblemDetails

    export const usePostApiWebhooksCustomerioSmsTransactionalOptOut = <TError = MvcProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsTransactionalOptOut>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWebhooksCustomerioSmsTransactionalOptOut>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiWebhooksCustomerioSmsTransactionalOptOutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

export const postApiWebhooksCustomerioEmailMarketingOptOut = (

 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/webhooks/customerio/email/marketing-opt-out`, method: 'POST', signal
    },
      );
    }



export const getPostApiWebhooksCustomerioEmailMarketingOptOutMutationOptions = <TError = MvcProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksCustomerioEmailMarketingOptOut>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksCustomerioEmailMarketingOptOut>>, TError,void, TContext> => {

const mutationKey = ['postApiWebhooksCustomerioEmailMarketingOptOut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWebhooksCustomerioEmailMarketingOptOut>>, void> = () => {


          return  postApiWebhooksCustomerioEmailMarketingOptOut()
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiWebhooksCustomerioEmailMarketingOptOutMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWebhooksCustomerioEmailMarketingOptOut>>>

    export type PostApiWebhooksCustomerioEmailMarketingOptOutMutationError = MvcProblemDetails

    export const usePostApiWebhooksCustomerioEmailMarketingOptOut = <TError = MvcProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebhooksCustomerioEmailMarketingOptOut>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWebhooksCustomerioEmailMarketingOptOut>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiWebhooksCustomerioEmailMarketingOptOutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Called by front end periodically while a user listens to a devo
 * @summary Add devo listen progress event
 */
export const postApiDevosListenEvent = (
    postListenProgress: PostListenProgress,
 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/devos/listen-event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postListenProgress, signal
    },
      );
    }



export const getPostApiDevosListenEventMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDevosListenEvent>>, TError,{data: PostListenProgress}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiDevosListenEvent>>, TError,{data: PostListenProgress}, TContext> => {

const mutationKey = ['postApiDevosListenEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiDevosListenEvent>>, {data: PostListenProgress}> = (props) => {
          const {data} = props ?? {};

          return  postApiDevosListenEvent(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiDevosListenEventMutationResult = NonNullable<Awaited<ReturnType<typeof postApiDevosListenEvent>>>
    export type PostApiDevosListenEventMutationBody = PostListenProgress
    export type PostApiDevosListenEventMutationError = void

    /**
 * @summary Add devo listen progress event
 */
export const usePostApiDevosListenEvent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDevosListenEvent>>, TError,{data: PostListenProgress}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiDevosListenEvent>>,
        TError,
        {data: PostListenProgress},
        TContext
      > => {

      const mutationOptions = getPostApiDevosListenEventMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Returns user's latest progress for specified devos, or top recent in-progress if none specified. Includes completion timestamp when user has reached 90%+ progress.
 * @summary Get latest devo listen progress
 */
export const getApiDevosProgress = (
    params?: GetApiDevosProgressParams,
 signal?: AbortSignal
) => {


      return apiMutator<GetContentProgress[]>(
      {url: `/api/devos/progress`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiDevosProgressQueryKey = (params?: GetApiDevosProgressParams,) => {
    return [
    `/api/devos/progress`, ...(params ? [params]: [])
    ] as const;
    }


export const getGetApiDevosProgressQueryOptions = <TData = Awaited<ReturnType<typeof getApiDevosProgress>>, TError = void>(params?: GetApiDevosProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDevosProgressQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDevosProgress>>> = ({ signal }) => getApiDevosProgress(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDevosProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiDevosProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDevosProgress>>>
export type GetApiDevosProgressQueryError = void


export function useGetApiDevosProgress<TData = Awaited<ReturnType<typeof getApiDevosProgress>>, TError = void>(
 params: undefined |  GetApiDevosProgressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevosProgress>>,
          TError,
          Awaited<ReturnType<typeof getApiDevosProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiDevosProgress<TData = Awaited<ReturnType<typeof getApiDevosProgress>>, TError = void>(
 params?: GetApiDevosProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevosProgress>>,
          TError,
          Awaited<ReturnType<typeof getApiDevosProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiDevosProgress<TData = Awaited<ReturnType<typeof getApiDevosProgress>>, TError = void>(
 params?: GetApiDevosProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get latest devo listen progress
 */

export function useGetApiDevosProgress<TData = Awaited<ReturnType<typeof getApiDevosProgress>>, TError = void>(
 params?: GetApiDevosProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiDevosProgressQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns user's progress for all devotionals in a specified series. Includes completion timestamp when user has reached 90%+ progress.
 * @summary Get devotional series progress
 */
export const getApiDevosSeriesProgress = (
    params?: GetApiDevosSeriesProgressParams,
 signal?: AbortSignal
) => {


      return apiMutator<GetDevotionalSeriesProgress>(
      {url: `/api/devos/series-progress`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiDevosSeriesProgressQueryKey = (params?: GetApiDevosSeriesProgressParams,) => {
    return [
    `/api/devos/series-progress`, ...(params ? [params]: [])
    ] as const;
    }


export const getGetApiDevosSeriesProgressQueryOptions = <TData = Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError = void>(params?: GetApiDevosSeriesProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDevosSeriesProgressQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDevosSeriesProgress>>> = ({ signal }) => getApiDevosSeriesProgress(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiDevosSeriesProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDevosSeriesProgress>>>
export type GetApiDevosSeriesProgressQueryError = void


export function useGetApiDevosSeriesProgress<TData = Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError = void>(
 params: undefined |  GetApiDevosSeriesProgressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevosSeriesProgress>>,
          TError,
          Awaited<ReturnType<typeof getApiDevosSeriesProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiDevosSeriesProgress<TData = Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError = void>(
 params?: GetApiDevosSeriesProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevosSeriesProgress>>,
          TError,
          Awaited<ReturnType<typeof getApiDevosSeriesProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiDevosSeriesProgress<TData = Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError = void>(
 params?: GetApiDevosSeriesProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get devotional series progress
 */

export function useGetApiDevosSeriesProgress<TData = Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError = void>(
 params?: GetApiDevosSeriesProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosSeriesProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiDevosSeriesProgressQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns streak metrics from completion history in the user's timezone.
                       Day streaks are based on consecutive weekdays.
                       Week streak uses Monday-Sunday calendar weeks, and only Monday-Friday completions qualify a week.
                       Saturday/Sunday completions never contribute to weekStreak.
                       A partial current week counts only if it already contains at least one Monday-Friday completion.
 * @summary Get user's listening streak
 */
export const getApiDevosStreak = (

 signal?: AbortSignal
) => {


      return apiMutator<GetStreakInfo>(
      {url: `/api/devos/streak`, method: 'GET', signal
    },
      );
    }




export const getGetApiDevosStreakQueryKey = () => {
    return [
    `/api/devos/streak`
    ] as const;
    }


export const getGetApiDevosStreakQueryOptions = <TData = Awaited<ReturnType<typeof getApiDevosStreak>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreak>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDevosStreakQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDevosStreak>>> = ({ signal }) => getApiDevosStreak(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreak>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiDevosStreakQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDevosStreak>>>
export type GetApiDevosStreakQueryError = void


export function useGetApiDevosStreak<TData = Awaited<ReturnType<typeof getApiDevosStreak>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreak>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevosStreak>>,
          TError,
          Awaited<ReturnType<typeof getApiDevosStreak>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiDevosStreak<TData = Awaited<ReturnType<typeof getApiDevosStreak>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreak>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevosStreak>>,
          TError,
          Awaited<ReturnType<typeof getApiDevosStreak>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiDevosStreak<TData = Awaited<ReturnType<typeof getApiDevosStreak>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreak>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get user's listening streak
 */

export function useGetApiDevosStreak<TData = Awaited<ReturnType<typeof getApiDevosStreak>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreak>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiDevosStreakQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns a list of dates when the user completed devotionals (weekdays only).
                       Dates are in ISO format (YYYY-MM-DD) in the user's timezone.
 * @summary Get user's listening history days
 */
export const getApiDevosStreakHistory = (

 signal?: AbortSignal
) => {


      return apiMutator<GetListenHistoryResponse>(
      {url: `/api/devos/streak/history`, method: 'GET', signal
    },
      );
    }




export const getGetApiDevosStreakHistoryQueryKey = () => {
    return [
    `/api/devos/streak/history`
    ] as const;
    }


export const getGetApiDevosStreakHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDevosStreakHistoryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDevosStreakHistory>>> = ({ signal }) => getApiDevosStreakHistory(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiDevosStreakHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDevosStreakHistory>>>
export type GetApiDevosStreakHistoryQueryError = void


export function useGetApiDevosStreakHistory<TData = Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevosStreakHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiDevosStreakHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiDevosStreakHistory<TData = Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDevosStreakHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiDevosStreakHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiDevosStreakHistory<TData = Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get user's listening history days
 */

export function useGetApiDevosStreakHistory<TData = Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDevosStreakHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiDevosStreakHistoryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List of CMS IDs that have been favorited by the user
 */
export const getApiFavorites = (

 signal?: AbortSignal
) => {


      return apiMutator<string[]>(
      {url: `/api/favorites`, method: 'GET', signal
    },
      );
    }




export const getGetApiFavoritesQueryKey = () => {
    return [
    `/api/favorites`
    ] as const;
    }


export const getGetApiFavoritesQueryOptions = <TData = Awaited<ReturnType<typeof getApiFavorites>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFavorites>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiFavoritesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiFavorites>>> = ({ signal }) => getApiFavorites(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiFavorites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiFavoritesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiFavorites>>>
export type GetApiFavoritesQueryError = void


export function useGetApiFavorites<TData = Awaited<ReturnType<typeof getApiFavorites>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFavorites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiFavorites>>,
          TError,
          Awaited<ReturnType<typeof getApiFavorites>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiFavorites<TData = Awaited<ReturnType<typeof getApiFavorites>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFavorites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiFavorites>>,
          TError,
          Awaited<ReturnType<typeof getApiFavorites>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiFavorites<TData = Awaited<ReturnType<typeof getApiFavorites>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFavorites>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List of CMS IDs that have been favorited by the user
 */

export function useGetApiFavorites<TData = Awaited<ReturnType<typeof getApiFavorites>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFavorites>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiFavoritesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Add a favorite for a user
 */
export const postApiFavorites = (
    postFavorite: PostFavorite,
 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/favorites`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postFavorite, signal
    },
      );
    }



export const getPostApiFavoritesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiFavorites>>, TError,{data: PostFavorite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiFavorites>>, TError,{data: PostFavorite}, TContext> => {

const mutationKey = ['postApiFavorites'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiFavorites>>, {data: PostFavorite}> = (props) => {
          const {data} = props ?? {};

          return  postApiFavorites(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiFavoritesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiFavorites>>>
    export type PostApiFavoritesMutationBody = PostFavorite
    export type PostApiFavoritesMutationError = void

    /**
 * @summary Add a favorite for a user
 */
export const usePostApiFavorites = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiFavorites>>, TError,{data: PostFavorite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiFavorites>>,
        TError,
        {data: PostFavorite},
        TContext
      > => {

      const mutationOptions = getPostApiFavoritesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * @summary Delete a favorite for a user
 */
export const deleteApiFavorites = (
    postFavorite: PostFavorite,
 ) => {


      return apiMutator<void>(
      {url: `/api/favorites`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: postFavorite
    },
      );
    }



export const getDeleteApiFavoritesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiFavorites>>, TError,{data: PostFavorite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiFavorites>>, TError,{data: PostFavorite}, TContext> => {

const mutationKey = ['deleteApiFavorites'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiFavorites>>, {data: PostFavorite}> = (props) => {
          const {data} = props ?? {};

          return  deleteApiFavorites(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiFavoritesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiFavorites>>>
    export type DeleteApiFavoritesMutationBody = PostFavorite
    export type DeleteApiFavoritesMutationError = void

    /**
 * @summary Delete a favorite for a user
 */
export const useDeleteApiFavorites = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiFavorites>>, TError,{data: PostFavorite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiFavorites>>,
        TError,
        {data: PostFavorite},
        TContext
      > => {

      const mutationOptions = getDeleteApiFavoritesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Used by front-end to confirm that the user is signed in
 * @summary Get user info and confirms cookie is still valid
 */
export const getApiMe = (

 signal?: AbortSignal
) => {


      return apiMutator<GetUser>(
      {url: `/api/me`, method: 'GET', signal
    },
      );
    }




export const getGetApiMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetApiMeQueryOptions = <TData = Awaited<ReturnType<typeof getApiMe>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMe>>> = ({ signal }) => getApiMe(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiMeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMe>>>
export type GetApiMeQueryError = void


export function useGetApiMe<TData = Awaited<ReturnType<typeof getApiMe>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMe>>,
          TError,
          Awaited<ReturnType<typeof getApiMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiMe<TData = Awaited<ReturnType<typeof getApiMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMe>>,
          TError,
          Awaited<ReturnType<typeof getApiMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiMe<TData = Awaited<ReturnType<typeof getApiMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get user info and confirms cookie is still valid
 */

export function useGetApiMe<TData = Awaited<ReturnType<typeof getApiMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates daily text notification preferences from explicit user intent.
 * @summary Update notification settings
 */
export const putApiNotificationSettings = (
    modelsUpdateNotificationSettingsRequest: ModelsUpdateNotificationSettingsRequest,
 ) => {


      return apiMutator<void>(
      {url: `/api/notification-settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelsUpdateNotificationSettingsRequest
    },
      );
    }



export const getPutApiNotificationSettingsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettings>>, TError,{data: ModelsUpdateNotificationSettingsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettings>>, TError,{data: ModelsUpdateNotificationSettingsRequest}, TContext> => {

const mutationKey = ['putApiNotificationSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiNotificationSettings>>, {data: ModelsUpdateNotificationSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  putApiNotificationSettings(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PutApiNotificationSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiNotificationSettings>>>
    export type PutApiNotificationSettingsMutationBody = ModelsUpdateNotificationSettingsRequest
    export type PutApiNotificationSettingsMutationError = void

    /**
 * @summary Update notification settings
 */
export const usePutApiNotificationSettings = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettings>>, TError,{data: ModelsUpdateNotificationSettingsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiNotificationSettings>>,
        TError,
        {data: ModelsUpdateNotificationSettingsRequest},
        TContext
      > => {

      const mutationOptions = getPutApiNotificationSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Records explicit SMS marketing consent and assigns Customer.io marketing routing.
 * @summary Update SMS marketing consent
 */
export const putApiNotificationSettingsSmsMarketingConsent = (
    modelsUpdateSmsMarketingConsentRequest: ModelsUpdateSmsMarketingConsentRequest,
 ) => {


      return apiMutator<ModelsSmsMarketingConsentResponse>(
      {url: `/api/notification-settings/sms-marketing-consent`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelsUpdateSmsMarketingConsentRequest
    },
      );
    }



export const getPutApiNotificationSettingsSmsMarketingConsentMutationOptions = <TError = MvcProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettingsSmsMarketingConsent>>, TError,{data: ModelsUpdateSmsMarketingConsentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettingsSmsMarketingConsent>>, TError,{data: ModelsUpdateSmsMarketingConsentRequest}, TContext> => {

const mutationKey = ['putApiNotificationSettingsSmsMarketingConsent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiNotificationSettingsSmsMarketingConsent>>, {data: ModelsUpdateSmsMarketingConsentRequest}> = (props) => {
          const {data} = props ?? {};

          return  putApiNotificationSettingsSmsMarketingConsent(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PutApiNotificationSettingsSmsMarketingConsentMutationResult = NonNullable<Awaited<ReturnType<typeof putApiNotificationSettingsSmsMarketingConsent>>>
    export type PutApiNotificationSettingsSmsMarketingConsentMutationBody = ModelsUpdateSmsMarketingConsentRequest
    export type PutApiNotificationSettingsSmsMarketingConsentMutationError = MvcProblemDetails | void

    /**
 * @summary Update SMS marketing consent
 */
export const usePutApiNotificationSettingsSmsMarketingConsent = <TError = MvcProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettingsSmsMarketingConsent>>, TError,{data: ModelsUpdateSmsMarketingConsentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiNotificationSettingsSmsMarketingConsent>>,
        TError,
        {data: ModelsUpdateSmsMarketingConsentRequest},
        TContext
      > => {

      const mutationOptions = getPutApiNotificationSettingsSmsMarketingConsentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Used by Twilio webhook when receiving messages
 * @summary Opt user in or out by keyword or opt out type
 */
export const postApiOptIn = (
    postApiOptInBody: PostApiOptInBody,
 signal?: AbortSignal
) => {

      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append(`From`, postApiOptInBody.From)
if(postApiOptInBody.Body !== undefined) {
 formUrlEncoded.append(`Body`, postApiOptInBody.Body)
 }
if(postApiOptInBody.OptOutType !== undefined) {
 formUrlEncoded.append(`OptOutType`, postApiOptInBody.OptOutType)
 }

      return apiMutator<void>(
      {url: `/api/opt-in`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded, signal
    },
      );
    }



export const getPostApiOptInMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOptIn>>, TError,{data: PostApiOptInBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiOptIn>>, TError,{data: PostApiOptInBody}, TContext> => {

const mutationKey = ['postApiOptIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOptIn>>, {data: PostApiOptInBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiOptIn(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiOptInMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOptIn>>>
    export type PostApiOptInMutationBody = PostApiOptInBody
    export type PostApiOptInMutationError = unknown

    /**
 * @summary Opt user in or out by keyword or opt out type
 */
export const usePostApiOptIn = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOptIn>>, TError,{data: PostApiOptInBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiOptIn>>,
        TError,
        {data: PostApiOptInBody},
        TContext
      > => {

      const mutationOptions = getPostApiOptInMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Used by Twilio webhook when receiving messages
 * @summary Opt user in or out by keyword or opt out type
 */
export const postApiOptInPbt = (
    postPBTMessage: PostPBTMessage,
 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/opt-in/pbt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postPBTMessage, signal
    },
      );
    }



export const getPostApiOptInPbtMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOptInPbt>>, TError,{data: PostPBTMessage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiOptInPbt>>, TError,{data: PostPBTMessage}, TContext> => {

const mutationKey = ['postApiOptInPbt'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOptInPbt>>, {data: PostPBTMessage}> = (props) => {
          const {data} = props ?? {};

          return  postApiOptInPbt(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiOptInPbtMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOptInPbt>>>
    export type PostApiOptInPbtMutationBody = PostPBTMessage
    export type PostApiOptInPbtMutationError = unknown

    /**
 * @summary Opt user in or out by keyword or opt out type
 */
export const usePostApiOptInPbt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOptInPbt>>, TError,{data: PostPBTMessage}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiOptInPbt>>,
        TError,
        {data: PostPBTMessage},
        TContext
      > => {

      const mutationOptions = getPostApiOptInPbtMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Used by PBT webhook when receiving messages
 * @summary Opt user in or out by keyword or opt out type
 */
export const postApiPbtIncomingMessage = (
    postPBTMessage: PostPBTMessage,
 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/pbt/incoming-message`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postPBTMessage, signal
    },
      );
    }



export const getPostApiPbtIncomingMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPbtIncomingMessage>>, TError,{data: PostPBTMessage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiPbtIncomingMessage>>, TError,{data: PostPBTMessage}, TContext> => {

const mutationKey = ['postApiPbtIncomingMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPbtIncomingMessage>>, {data: PostPBTMessage}> = (props) => {
          const {data} = props ?? {};

          return  postApiPbtIncomingMessage(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiPbtIncomingMessageMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPbtIncomingMessage>>>
    export type PostApiPbtIncomingMessageMutationBody = PostPBTMessage
    export type PostApiPbtIncomingMessageMutationError = unknown

    /**
 * @summary Opt user in or out by keyword or opt out type
 */
export const usePostApiPbtIncomingMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPbtIncomingMessage>>, TError,{data: PostPBTMessage}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPbtIncomingMessage>>,
        TError,
        {data: PostPBTMessage},
        TContext
      > => {

      const mutationOptions = getPostApiPbtIncomingMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Used by PBT webhook when receiving message status
 * @summary Opt people out once the number receives 3 failures
 */
export const postApiPbtMessageStatus = (
    postPBTStatusMessage: PostPBTStatusMessage,
 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/pbt/message-status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postPBTStatusMessage, signal
    },
      );
    }



export const getPostApiPbtMessageStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPbtMessageStatus>>, TError,{data: PostPBTStatusMessage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiPbtMessageStatus>>, TError,{data: PostPBTStatusMessage}, TContext> => {

const mutationKey = ['postApiPbtMessageStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPbtMessageStatus>>, {data: PostPBTStatusMessage}> = (props) => {
          const {data} = props ?? {};

          return  postApiPbtMessageStatus(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiPbtMessageStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPbtMessageStatus>>>
    export type PostApiPbtMessageStatusMutationBody = PostPBTStatusMessage
    export type PostApiPbtMessageStatusMutationError = unknown

    /**
 * @summary Opt people out once the number receives 3 failures
 */
export const usePostApiPbtMessageStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPbtMessageStatus>>, TError,{data: PostPBTStatusMessage}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPbtMessageStatus>>,
        TError,
        {data: PostPBTStatusMessage},
        TContext
      > => {

      const mutationOptions = getPostApiPbtMessageStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Saves referral information for the user
 * @summary Add referral information (utm_)
 */
export const postApiReferral = (
    postReferral: PostReferral,
 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/referral`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postReferral, signal
    },
      );
    }



export const getPostApiReferralMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiReferral>>, TError,{data: PostReferral}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiReferral>>, TError,{data: PostReferral}, TContext> => {

const mutationKey = ['postApiReferral'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiReferral>>, {data: PostReferral}> = (props) => {
          const {data} = props ?? {};

          return  postApiReferral(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiReferralMutationResult = NonNullable<Awaited<ReturnType<typeof postApiReferral>>>
    export type PostApiReferralMutationBody = PostReferral
    export type PostApiReferralMutationError = void

    /**
 * @summary Add referral information (utm_)
 */
export const usePostApiReferral = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiReferral>>, TError,{data: PostReferral}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiReferral>>,
        TError,
        {data: PostReferral},
        TContext
      > => {

      const mutationOptions = getPostApiReferralMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Returns count of users who signed up from the authenticated user's referral links (ref_user)
 * @summary Get referral metrics for authenticated user
 */
export const getApiReferralMetrics = (
    params?: GetApiReferralMetricsParams,
 signal?: AbortSignal
) => {


      return apiMutator<GetReferralMetrics>(
      {url: `/api/referral/metrics`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiReferralMetricsQueryKey = (params?: GetApiReferralMetricsParams,) => {
    return [
    `/api/referral/metrics`, ...(params ? [params]: [])
    ] as const;
    }


export const getGetApiReferralMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getApiReferralMetrics>>, TError = void>(params?: GetApiReferralMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiReferralMetrics>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiReferralMetricsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiReferralMetrics>>> = ({ signal }) => getApiReferralMetrics(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiReferralMetrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiReferralMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiReferralMetrics>>>
export type GetApiReferralMetricsQueryError = void


export function useGetApiReferralMetrics<TData = Awaited<ReturnType<typeof getApiReferralMetrics>>, TError = void>(
 params: undefined |  GetApiReferralMetricsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiReferralMetrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiReferralMetrics>>,
          TError,
          Awaited<ReturnType<typeof getApiReferralMetrics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiReferralMetrics<TData = Awaited<ReturnType<typeof getApiReferralMetrics>>, TError = void>(
 params?: GetApiReferralMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiReferralMetrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiReferralMetrics>>,
          TError,
          Awaited<ReturnType<typeof getApiReferralMetrics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiReferralMetrics<TData = Awaited<ReturnType<typeof getApiReferralMetrics>>, TError = void>(
 params?: GetApiReferralMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiReferralMetrics>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get referral metrics for authenticated user
 */

export function useGetApiReferralMetrics<TData = Awaited<ReturnType<typeof getApiReferralMetrics>>, TError = void>(
 params?: GetApiReferralMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiReferralMetrics>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiReferralMetricsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List of CMS IDs for series that have been followed by the user
 */
export const getApiSeriesFollow = (

 signal?: AbortSignal
) => {


      return apiMutator<string[]>(
      {url: `/api/series/follow`, method: 'GET', signal
    },
      );
    }




export const getGetApiSeriesFollowQueryKey = () => {
    return [
    `/api/series/follow`
    ] as const;
    }


export const getGetApiSeriesFollowQueryOptions = <TData = Awaited<ReturnType<typeof getApiSeriesFollow>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSeriesFollow>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSeriesFollowQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSeriesFollow>>> = ({ signal }) => getApiSeriesFollow(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSeriesFollow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiSeriesFollowQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSeriesFollow>>>
export type GetApiSeriesFollowQueryError = void


export function useGetApiSeriesFollow<TData = Awaited<ReturnType<typeof getApiSeriesFollow>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSeriesFollow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSeriesFollow>>,
          TError,
          Awaited<ReturnType<typeof getApiSeriesFollow>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiSeriesFollow<TData = Awaited<ReturnType<typeof getApiSeriesFollow>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSeriesFollow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSeriesFollow>>,
          TError,
          Awaited<ReturnType<typeof getApiSeriesFollow>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiSeriesFollow<TData = Awaited<ReturnType<typeof getApiSeriesFollow>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSeriesFollow>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List of CMS IDs for series that have been followed by the user
 */

export function useGetApiSeriesFollow<TData = Awaited<ReturnType<typeof getApiSeriesFollow>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSeriesFollow>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiSeriesFollowQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Follow a series for a user
 */
export const postApiSeriesFollow = (
    postFollowSeries: PostFollowSeries,
 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/series/follow`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postFollowSeries, signal
    },
      );
    }



export const getPostApiSeriesFollowMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSeriesFollow>>, TError,{data: PostFollowSeries}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiSeriesFollow>>, TError,{data: PostFollowSeries}, TContext> => {

const mutationKey = ['postApiSeriesFollow'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSeriesFollow>>, {data: PostFollowSeries}> = (props) => {
          const {data} = props ?? {};

          return  postApiSeriesFollow(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiSeriesFollowMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSeriesFollow>>>
    export type PostApiSeriesFollowMutationBody = PostFollowSeries
    export type PostApiSeriesFollowMutationError = void

    /**
 * @summary Follow a series for a user
 */
export const usePostApiSeriesFollow = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSeriesFollow>>, TError,{data: PostFollowSeries}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSeriesFollow>>,
        TError,
        {data: PostFollowSeries},
        TContext
      > => {

      const mutationOptions = getPostApiSeriesFollowMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * @summary Unfollow a series for a user
 */
export const deleteApiSeriesFollow = (
    postFollowSeries: PostFollowSeries,
 ) => {


      return apiMutator<void>(
      {url: `/api/series/follow`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: postFollowSeries
    },
      );
    }



export const getDeleteApiSeriesFollowMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiSeriesFollow>>, TError,{data: PostFollowSeries}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiSeriesFollow>>, TError,{data: PostFollowSeries}, TContext> => {

const mutationKey = ['deleteApiSeriesFollow'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiSeriesFollow>>, {data: PostFollowSeries}> = (props) => {
          const {data} = props ?? {};

          return  deleteApiSeriesFollow(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiSeriesFollowMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiSeriesFollow>>>
    export type DeleteApiSeriesFollowMutationBody = PostFollowSeries
    export type DeleteApiSeriesFollowMutationError = void

    /**
 * @summary Unfollow a series for a user
 */
export const useDeleteApiSeriesFollow = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiSeriesFollow>>, TError,{data: PostFollowSeries}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiSeriesFollow>>,
        TError,
        {data: PostFollowSeries},
        TContext
      > => {

      const mutationOptions = getDeleteApiSeriesFollowMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * @summary Record a share event when a user shares content
 */
export const postApiShareEvent = (
    postShareEventRequest: PostShareEventRequest,
 signal?: AbortSignal
) => {


      return apiMutator<unknown>(
      {url: `/api/share/event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postShareEventRequest, signal
    },
      );
    }



export const getPostApiShareEventMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiShareEvent>>, TError,{data: PostShareEventRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiShareEvent>>, TError,{data: PostShareEventRequest}, TContext> => {

const mutationKey = ['postApiShareEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiShareEvent>>, {data: PostShareEventRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiShareEvent(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiShareEventMutationResult = NonNullable<Awaited<ReturnType<typeof postApiShareEvent>>>
    export type PostApiShareEventMutationBody = PostShareEventRequest
    export type PostApiShareEventMutationError = void

    /**
 * @summary Record a share event when a user shares content
 */
export const usePostApiShareEvent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiShareEvent>>, TError,{data: PostShareEventRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiShareEvent>>,
        TError,
        {data: PostShareEventRequest},
        TContext
      > => {

      const mutationOptions = getPostApiShareEventMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * @summary Get the total share count for a specific content item
 */
export const getApiShareCountCmsId = (
    cmsId: string,
 signal?: AbortSignal
) => {


      return apiMutator<GetShareCountResponse>(
      {url: `/api/share/count/${cmsId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiShareCountCmsIdQueryKey = (cmsId?: string,) => {
    return [
    `/api/share/count/${cmsId}`
    ] as const;
    }


export const getGetApiShareCountCmsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError = void>(cmsId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiShareCountCmsIdQueryKey(cmsId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiShareCountCmsId>>> = ({ signal }) => getApiShareCountCmsId(cmsId, signal);





   return  { queryKey, queryFn, enabled: !!(cmsId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiShareCountCmsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiShareCountCmsId>>>
export type GetApiShareCountCmsIdQueryError = void


export function useGetApiShareCountCmsId<TData = Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError = void>(
 cmsId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiShareCountCmsId>>,
          TError,
          Awaited<ReturnType<typeof getApiShareCountCmsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiShareCountCmsId<TData = Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError = void>(
 cmsId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiShareCountCmsId>>,
          TError,
          Awaited<ReturnType<typeof getApiShareCountCmsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiShareCountCmsId<TData = Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError = void>(
 cmsId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the total share count for a specific content item
 */

export function useGetApiShareCountCmsId<TData = Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError = void>(
 cmsId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareCountCmsId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiShareCountCmsIdQueryOptions(cmsId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get the authenticated user's total shares and 5 most recently shared CMS IDs
 */
export const getApiShareMe = (

 signal?: AbortSignal
) => {


      return apiMutator<GetUserShareStatsResponse>(
      {url: `/api/share/me`, method: 'GET', signal
    },
      );
    }




export const getGetApiShareMeQueryKey = () => {
    return [
    `/api/share/me`
    ] as const;
    }


export const getGetApiShareMeQueryOptions = <TData = Awaited<ReturnType<typeof getApiShareMe>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiShareMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiShareMe>>> = ({ signal }) => getApiShareMe(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiShareMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiShareMeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiShareMe>>>
export type GetApiShareMeQueryError = void


export function useGetApiShareMe<TData = Awaited<ReturnType<typeof getApiShareMe>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiShareMe>>,
          TError,
          Awaited<ReturnType<typeof getApiShareMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiShareMe<TData = Awaited<ReturnType<typeof getApiShareMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiShareMe>>,
          TError,
          Awaited<ReturnType<typeof getApiShareMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiShareMe<TData = Awaited<ReturnType<typeof getApiShareMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the authenticated user's total shares and 5 most recently shared CMS IDs
 */

export function useGetApiShareMe<TData = Awaited<ReturnType<typeof getApiShareMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareMe>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiShareMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns minimal display data for a sharer. Unknown users return empty fields.
 * @summary Resolve sharer display name
 */
export const getApiShareSharerExternalId = (
    externalId: string,
 signal?: AbortSignal
) => {


      return apiMutator<GetSharerDisplayNameResponse>(
      {url: `/api/share/sharer/${externalId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiShareSharerExternalIdQueryKey = (externalId?: string,) => {
    return [
    `/api/share/sharer/${externalId}`
    ] as const;
    }


export const getGetApiShareSharerExternalIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError = void>(externalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiShareSharerExternalIdQueryKey(externalId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiShareSharerExternalId>>> = ({ signal }) => getApiShareSharerExternalId(externalId, signal);





   return  { queryKey, queryFn, enabled: !!(externalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiShareSharerExternalIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiShareSharerExternalId>>>
export type GetApiShareSharerExternalIdQueryError = void


export function useGetApiShareSharerExternalId<TData = Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError = void>(
 externalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiShareSharerExternalId>>,
          TError,
          Awaited<ReturnType<typeof getApiShareSharerExternalId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiShareSharerExternalId<TData = Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError = void>(
 externalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiShareSharerExternalId>>,
          TError,
          Awaited<ReturnType<typeof getApiShareSharerExternalId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiShareSharerExternalId<TData = Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError = void>(
 externalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Resolve sharer display name
 */

export function useGetApiShareSharerExternalId<TData = Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError = void>(
 externalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiShareSharerExternalId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiShareSharerExternalIdQueryOptions(externalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Currently watching for customer.created, customer.updated, customer.subscription.created,
                customer.subscription.updated, checkout.session.completed, and invoice.upcoming events
 * @summary Webhook for Stripe to post events
 */
export const postApiStripeWebhook = (

 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/stripe/webhook`, method: 'POST', signal
    },
      );
    }



export const getPostApiStripeWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStripeWebhook>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiStripeWebhook>>, TError,void, TContext> => {

const mutationKey = ['postApiStripeWebhook'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStripeWebhook>>, void> = () => {


          return  postApiStripeWebhook()
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiStripeWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStripeWebhook>>>

    export type PostApiStripeWebhookMutationError = unknown

    /**
 * @summary Webhook for Stripe to post events
 */
export const usePostApiStripeWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStripeWebhook>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiStripeWebhook>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiStripeWebhookMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Used to get the product pricing for the user.
 * @summary Get Product Pricing
 */
export const getApiStripePrices = (

 signal?: AbortSignal
) => {


      return apiMutator<GetPrice[]>(
      {url: `/api/stripe/prices`, method: 'GET', signal
    },
      );
    }




export const getGetApiStripePricesQueryKey = () => {
    return [
    `/api/stripe/prices`
    ] as const;
    }


export const getGetApiStripePricesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStripePrices>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePrices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStripePricesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStripePrices>>> = ({ signal }) => getApiStripePrices(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStripePrices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiStripePricesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStripePrices>>>
export type GetApiStripePricesQueryError = void


export function useGetApiStripePrices<TData = Awaited<ReturnType<typeof getApiStripePrices>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePrices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripePrices>>,
          TError,
          Awaited<ReturnType<typeof getApiStripePrices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripePrices<TData = Awaited<ReturnType<typeof getApiStripePrices>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePrices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripePrices>>,
          TError,
          Awaited<ReturnType<typeof getApiStripePrices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripePrices<TData = Awaited<ReturnType<typeof getApiStripePrices>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePrices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Product Pricing
 */

export function useGetApiStripePrices<TData = Awaited<ReturnType<typeof getApiStripePrices>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePrices>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiStripePricesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Used to get the checkout session for the user.
 * @summary Get Checkout Session
 */
export const getApiStripeCheckoutSession = (
    params?: GetApiStripeCheckoutSessionParams,
 signal?: AbortSignal
) => {


      return apiMutator<string>(
      {url: `/api/stripe/checkout-session`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiStripeCheckoutSessionQueryKey = (params?: GetApiStripeCheckoutSessionParams,) => {
    return [
    `/api/stripe/checkout-session`, ...(params ? [params]: [])
    ] as const;
    }


export const getGetApiStripeCheckoutSessionQueryOptions = <TData = Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError = void>(params?: GetApiStripeCheckoutSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStripeCheckoutSessionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStripeCheckoutSession>>> = ({ signal }) => getApiStripeCheckoutSession(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiStripeCheckoutSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStripeCheckoutSession>>>
export type GetApiStripeCheckoutSessionQueryError = void


export function useGetApiStripeCheckoutSession<TData = Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError = void>(
 params: undefined |  GetApiStripeCheckoutSessionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripeCheckoutSession>>,
          TError,
          Awaited<ReturnType<typeof getApiStripeCheckoutSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripeCheckoutSession<TData = Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError = void>(
 params?: GetApiStripeCheckoutSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripeCheckoutSession>>,
          TError,
          Awaited<ReturnType<typeof getApiStripeCheckoutSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripeCheckoutSession<TData = Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError = void>(
 params?: GetApiStripeCheckoutSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Checkout Session
 */

export function useGetApiStripeCheckoutSession<TData = Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError = void>(
 params?: GetApiStripeCheckoutSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeCheckoutSession>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiStripeCheckoutSessionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a Stripe checkout session for purchasing promo-code redemptions.
 * @summary Create promo-code purchase checkout session
 */
export const postApiStripePromotionCodeCheckoutSession = (
    postCreatePromotionCodeCheckoutSessionRequest: PostCreatePromotionCodeCheckoutSessionRequest,
 signal?: AbortSignal
) => {


      return apiMutator<GetCreatePromotionCodeCheckoutSessionResponse>(
      {url: `/api/stripe/promotion-code/checkout-session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCreatePromotionCodeCheckoutSessionRequest, signal
    },
      );
    }



export const getPostApiStripePromotionCodeCheckoutSessionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStripePromotionCodeCheckoutSession>>, TError,{data: PostCreatePromotionCodeCheckoutSessionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiStripePromotionCodeCheckoutSession>>, TError,{data: PostCreatePromotionCodeCheckoutSessionRequest}, TContext> => {

const mutationKey = ['postApiStripePromotionCodeCheckoutSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStripePromotionCodeCheckoutSession>>, {data: PostCreatePromotionCodeCheckoutSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiStripePromotionCodeCheckoutSession(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiStripePromotionCodeCheckoutSessionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStripePromotionCodeCheckoutSession>>>
    export type PostApiStripePromotionCodeCheckoutSessionMutationBody = PostCreatePromotionCodeCheckoutSessionRequest
    export type PostApiStripePromotionCodeCheckoutSessionMutationError = void

    /**
 * @summary Create promo-code purchase checkout session
 */
export const usePostApiStripePromotionCodeCheckoutSession = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStripePromotionCodeCheckoutSession>>, TError,{data: PostCreatePromotionCodeCheckoutSessionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiStripePromotionCodeCheckoutSession>>,
        TError,
        {data: PostCreatePromotionCodeCheckoutSessionRequest},
        TContext
      > => {

      const mutationOptions = getPostApiStripePromotionCodeCheckoutSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Returns promo codes purchased by the authenticated user with live Stripe redemption state.
 * @summary Get my owned promotion codes
 */
export const getApiStripePromotionCodeMy = (

 signal?: AbortSignal
) => {


      return apiMutator<GetMyPromotionCodeListResponse>(
      {url: `/api/stripe/promotion-code/my`, method: 'GET', signal
    },
      );
    }




export const getGetApiStripePromotionCodeMyQueryKey = () => {
    return [
    `/api/stripe/promotion-code/my`
    ] as const;
    }


export const getGetApiStripePromotionCodeMyQueryOptions = <TData = Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStripePromotionCodeMyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>> = ({ signal }) => getApiStripePromotionCodeMy(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiStripePromotionCodeMyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>>
export type GetApiStripePromotionCodeMyQueryError = void


export function useGetApiStripePromotionCodeMy<TData = Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>,
          TError,
          Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripePromotionCodeMy<TData = Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>,
          TError,
          Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripePromotionCodeMy<TData = Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get my owned promotion codes
 */

export function useGetApiStripePromotionCodeMy<TData = Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCodeMy>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiStripePromotionCodeMyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns information about the user's subscription status including key dates
 * @summary Get Subscription Status
 */
export const getApiStripeSubscriptionStatus = (

 signal?: AbortSignal
) => {


      return apiMutator<GetSubscriptionStatus>(
      {url: `/api/stripe/subscription/status`, method: 'GET', signal
    },
      );
    }




export const getGetApiStripeSubscriptionStatusQueryKey = () => {
    return [
    `/api/stripe/subscription/status`
    ] as const;
    }


export const getGetApiStripeSubscriptionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStripeSubscriptionStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>> = ({ signal }) => getApiStripeSubscriptionStatus(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiStripeSubscriptionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>>
export type GetApiStripeSubscriptionStatusQueryError = void


export function useGetApiStripeSubscriptionStatus<TData = Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripeSubscriptionStatus<TData = Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripeSubscriptionStatus<TData = Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Subscription Status
 */

export function useGetApiStripeSubscriptionStatus<TData = Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeSubscriptionStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiStripeSubscriptionStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Generates a URL to the Stripe billing portal for the authenticated user
 * @summary Get Stripe billing portal URL
 */
export const getApiStripeBillingPortal = (

 signal?: AbortSignal
) => {


      return apiMutator<GetPortalUrlResponse>(
      {url: `/api/stripe/billing-portal`, method: 'GET', signal
    },
      );
    }




export const getGetApiStripeBillingPortalQueryKey = () => {
    return [
    `/api/stripe/billing-portal`
    ] as const;
    }


export const getGetApiStripeBillingPortalQueryOptions = <TData = Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStripeBillingPortalQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStripeBillingPortal>>> = ({ signal }) => getApiStripeBillingPortal(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiStripeBillingPortalQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStripeBillingPortal>>>
export type GetApiStripeBillingPortalQueryError = void


export function useGetApiStripeBillingPortal<TData = Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripeBillingPortal>>,
          TError,
          Awaited<ReturnType<typeof getApiStripeBillingPortal>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripeBillingPortal<TData = Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripeBillingPortal>>,
          TError,
          Awaited<ReturnType<typeof getApiStripeBillingPortal>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripeBillingPortal<TData = Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Stripe billing portal URL
 */

export function useGetApiStripeBillingPortal<TData = Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripeBillingPortal>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiStripeBillingPortalQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Generates a URL to the Stripe billing portal specifically for updating payment methods
 * @summary Get Stripe payment method update portal URL
 */
export const getApiStripePaymentMethodPortal = (

 signal?: AbortSignal
) => {


      return apiMutator<GetPortalUrlResponse>(
      {url: `/api/stripe/payment-method-portal`, method: 'GET', signal
    },
      );
    }




export const getGetApiStripePaymentMethodPortalQueryKey = () => {
    return [
    `/api/stripe/payment-method-portal`
    ] as const;
    }


export const getGetApiStripePaymentMethodPortalQueryOptions = <TData = Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStripePaymentMethodPortalQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>> = ({ signal }) => getApiStripePaymentMethodPortal(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiStripePaymentMethodPortalQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>>
export type GetApiStripePaymentMethodPortalQueryError = void


export function useGetApiStripePaymentMethodPortal<TData = Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>,
          TError,
          Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripePaymentMethodPortal<TData = Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>,
          TError,
          Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripePaymentMethodPortal<TData = Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Stripe payment method update portal URL
 */

export function useGetApiStripePaymentMethodPortal<TData = Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePaymentMethodPortal>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiStripePaymentMethodPortalQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns information about a promotion code including discount details,
                           validity, and expiration. Use this to validate codes before checkout.
 * @summary Validate and retrieve promotion code information
 */
export const getApiStripePromotionCode = (
    params?: GetApiStripePromotionCodeParams,
 signal?: AbortSignal
) => {


      return apiMutator<GetPromotionCodeInfo>(
      {url: `/api/stripe/promotion-code`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiStripePromotionCodeQueryKey = (params?: GetApiStripePromotionCodeParams,) => {
    return [
    `/api/stripe/promotion-code`, ...(params ? [params]: [])
    ] as const;
    }


export const getGetApiStripePromotionCodeQueryOptions = <TData = Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError = void>(params?: GetApiStripePromotionCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStripePromotionCodeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStripePromotionCode>>> = ({ signal }) => getApiStripePromotionCode(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiStripePromotionCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStripePromotionCode>>>
export type GetApiStripePromotionCodeQueryError = void


export function useGetApiStripePromotionCode<TData = Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError = void>(
 params: undefined |  GetApiStripePromotionCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripePromotionCode>>,
          TError,
          Awaited<ReturnType<typeof getApiStripePromotionCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripePromotionCode<TData = Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError = void>(
 params?: GetApiStripePromotionCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStripePromotionCode>>,
          TError,
          Awaited<ReturnType<typeof getApiStripePromotionCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStripePromotionCode<TData = Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError = void>(
 params?: GetApiStripePromotionCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Validate and retrieve promotion code information
 */

export function useGetApiStripePromotionCode<TData = Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError = void>(
 params?: GetApiStripePromotionCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStripePromotionCode>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiStripePromotionCodeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a Stripe subscription with a promotion code applied.
 * @summary Create subscription with 100% off coupon
 */
export const postApiStripeSubscriptionCreateWithCoupon = (
    postCreateSubscriptionWithCouponRequest: PostCreateSubscriptionWithCouponRequest,
 signal?: AbortSignal
) => {


      return apiMutator<GetCreateSubscriptionWithCouponResponse>(
      {url: `/api/stripe/subscription/create-with-coupon`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCreateSubscriptionWithCouponRequest, signal
    },
      );
    }



export const getPostApiStripeSubscriptionCreateWithCouponMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStripeSubscriptionCreateWithCoupon>>, TError,{data: PostCreateSubscriptionWithCouponRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiStripeSubscriptionCreateWithCoupon>>, TError,{data: PostCreateSubscriptionWithCouponRequest}, TContext> => {

const mutationKey = ['postApiStripeSubscriptionCreateWithCoupon'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStripeSubscriptionCreateWithCoupon>>, {data: PostCreateSubscriptionWithCouponRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiStripeSubscriptionCreateWithCoupon(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiStripeSubscriptionCreateWithCouponMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStripeSubscriptionCreateWithCoupon>>>
    export type PostApiStripeSubscriptionCreateWithCouponMutationBody = PostCreateSubscriptionWithCouponRequest
    export type PostApiStripeSubscriptionCreateWithCouponMutationError = void

    /**
 * @summary Create subscription with 100% off coupon
 */
export const usePostApiStripeSubscriptionCreateWithCoupon = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStripeSubscriptionCreateWithCoupon>>, TError,{data: PostCreateSubscriptionWithCouponRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiStripeSubscriptionCreateWithCoupon>>,
        TError,
        {data: PostCreateSubscriptionWithCouponRequest},
        TContext
      > => {

      const mutationOptions = getPostApiStripeSubscriptionCreateWithCouponMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Updates user profile with partial update support. Only provided fields are updated.

    Demographic fields (birthYear, birthMonth) update independently.
    Church/address fields update as a set - if any church field is provided, all church fields are updated together.
 * @summary Update user profile
 */
export const putApiUser = (
    postUserProfile: PostUserProfile,
 ) => {


      return apiMutator<void>(
      {url: `/api/user`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: postUserProfile
    },
      );
    }



export const getPutApiUserMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUser>>, TError,{data: PostUserProfile}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiUser>>, TError,{data: PostUserProfile}, TContext> => {

const mutationKey = ['putApiUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiUser>>, {data: PostUserProfile}> = (props) => {
          const {data} = props ?? {};

          return  putApiUser(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type PutApiUserMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUser>>>
    export type PutApiUserMutationBody = PostUserProfile
    export type PutApiUserMutationError = void

    /**
 * @summary Update user profile
 */
export const usePutApiUser = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUser>>, TError,{data: PostUserProfile}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiUser>>,
        TError,
        {data: PostUserProfile},
        TContext
      > => {

      const mutationOptions = getPutApiUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

/**
 * Saves the datetime when user dismissed the promotional banner
 * @summary Dismiss promotional banner
 */
export const postApiUserDismissPromotionalBanner = (

 signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/api/user/dismiss-promotional-banner`, method: 'POST', signal
    },
      );
    }



export const getPostApiUserDismissPromotionalBannerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserDismissPromotionalBanner>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUserDismissPromotionalBanner>>, TError,void, TContext> => {

const mutationKey = ['postApiUserDismissPromotionalBanner'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserDismissPromotionalBanner>>, void> = () => {


          return  postApiUserDismissPromotionalBanner()
        }




  return  { mutationFn, ...mutationOptions }}

    export type PostApiUserDismissPromotionalBannerMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserDismissPromotionalBanner>>>

    export type PostApiUserDismissPromotionalBannerMutationError = void

    /**
 * @summary Dismiss promotional banner
 */
export const usePostApiUserDismissPromotionalBanner = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserDismissPromotionalBanner>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUserDismissPromotionalBanner>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiUserDismissPromotionalBannerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
